var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('b-image',{staticClass:"logo",attrs:{"src":"/img/overspacelogo.png"}}),_c('h2',{staticClass:"title is-4 headernew"},[_vm._v("We love mobile games, do you?")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }